/**
 * Speed mode helpers — centralizes turbo-like speed checks.
 *
 * Use `isTurboLike()` anywhere the codebase currently checks `=== "turbo"`
 * to automatically include super-turbo behavior (reel mechanics, animations).
 *
 * Use `isSuperTurbo()` where super-turbo needs DIFFERENT behavior
 * (e.g., win processing fast-path).
 */

/**
 * Returns true for both "turbo" and "super_turbo" speeds.
 * Use for reel mechanics, animation skipping, spacebar hold — anything
 * where super-turbo behaves identically to turbo.
 * @param {string} speed
 * @returns {boolean}
 */
export const isTurboLike = (speed) => speed === "turbo" || speed === "super_turbo";

/**
 * Returns true only for "super_turbo" speed.
 * Use where super-turbo has unique behavior (win fast-path, reduced delays).
 * @param {string} speed
 * @returns {boolean}
 */
export const isSuperTurbo = (speed) => speed === "super_turbo";


